/**
 * Handle hi level data format
 */
export enum HiLevelDataFormat {
  BOOLEAN = 0,
  INTEGER = 1,
  FLOAT = 2,
  TIME = 3,
  DATE = 4,
  STRING = 5,
  BYTE_ARRAY = 6,
  CHAR = 7,
  UNKNOWN = 8,
  DATETIME = 9,
  XML = 10,
}

export enum addressOperation {
  DoNotModify = 0,
  AddSubtract = 1,
  Value = 2,
}

export enum AddressFormat {
  AfString = 0,
  AfKNXTwoLevels = 1,
  AfKNXThreeLevels = 2,
  AfInteger = 3,
  AfStringIntegerInteger = 4,
  AfStringStringInteger = 5,
  AfStringStringString = 6,
  AfIntegerStringString = 7,
  AfIntegerIntegerString = 8,
  AfIntegerStringInteger = 9,
  AfStringIntegerString = 10,
  AfStringString = 11,
  AfIntegerString = 12,
  AfStringInteger = 13,
}
/**
 * Handle generic address default methods
 */
export enum AddressDefaultMethods {
  READ = "READ",
  WRITE = "WRITE",
}

export enum SelectionAddressOrAddressFunction {
  ADDRESS = 0,
  ADDRESS_FUNCTION = 1,
  SCENARIO = 2,
}
